/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menuscanerrortoolarge4Inputs */

const en_menuscanerrortoolarge4 = /** @type {(inputs: Menuscanerrortoolarge4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A file is too large: photos up to 10 MB, PDFs up to 15 MB.`)
};

const de_menuscanerrortoolarge4 = /** @type {(inputs: Menuscanerrortoolarge4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Datei ist zu groß: Fotos bis 10 MB, PDFs bis 15 MB.`)
};

/**
* | output |
* | --- |
* | "A file is too large: photos up to 10 MB, PDFs up to 15 MB." |
*
* @param {Menuscanerrortoolarge4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menuscanerrortoolarge4 = /** @type {((inputs?: Menuscanerrortoolarge4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menuscanerrortoolarge4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menuscanerrortoolarge4(inputs)
	return de_menuscanerrortoolarge4(inputs)
});
export { menuscanerrortoolarge4 as "menuScanErrorTooLarge" }